import { render, staticRenderFns } from "./financialRatios2.vue?vue&type=template&id=ec5ad03e&scoped=true"
import script from "./financialRatios2.vue?vue&type=script&lang=js"
export * from "./financialRatios2.vue?vue&type=script&lang=js"
import style0 from "./financialRatios2.vue?vue&type=style&index=0&id=ec5ad03e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ad03e",
  null
  
)

export default component.exports